import React, { useEffect, useState } from "react";
import _ from "lodash";
import { renderAlternateFormFields } from "../form/FormRenderer";
import { Modal } from "react-bootstrap";
import ConfigUtils from "../../utils/ConfigUtils";
import "../../styles/form.scss";
import {StyledBlueButton} from "../../styles/BootstrapStyles";

const Reveal = ({
  parentItem,
  isEditing,
  handleOption,
  data,
  showing,
  items,
  parentValue,
  error,
  dueDate,
  handleMultiple,
  mode
}) => {
  const inputComponents = ConfigUtils.getInputComponents();
  const [activeItems, setActiveItems] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (!showing) {
      _.map(activeItems, (item) => {
        handleOption(_.get(item, "ref"), null);
      });
    } else {
      if(_.isEmpty(mode)){
      let aItems = _.filter(items, (item) =>
        _.has(item, "selection")
          ? _.get(item, "selection")
          : _.get(item, "refData") === _.get(data, _.get(parentItem, "ref"))
      );
      if (_.has(aItems[0], "alert") && !_.has(data, _.get(aItems[0], "components")[0])) {
        setAlertMessage(_.get(aItems[0], "alert"));
        setAlert(true);
      }
      let fields = _.map(_.get(aItems[0], "components"), (key) => {
        let f = _.cloneDeep(_.get(inputComponents, "inputComponents")[0].dataFields[0][key]);
        let override = _.get(aItems[0], "override.metadata");
        if (_.includes(JSON.stringify(override), key, false)) {
          let findObj = _.find(override, (over) => _.has(over, key));
          f = Object.assign(f, _.get(findObj, key));
        }
        f.ref = key;
        return f;
      });
      _.map(activeItems,(fieldVal)=>{
        if(_.has(data,fieldVal.ref)){
          delete data[fieldVal.ref]
        }
      });
      setActiveItems(fields);
    }else{
      let value = _.get(_.find(_.get(parentItem, 'referenceDataSource'), (item)=> _.get(item, 'label') === _.get(data, _.get(parentItem, "ref"))), 'value');
      let parentData = _.first(items[value]);
      let f = _.cloneDeep(
        _.get(inputComponents, "inputComponents")[0].dataFields[0][parentData]
      );
      let override = _.get(parentData, "override.metadata");
      if (_.includes(JSON.stringify(override), parentData, false)) {
        let findObj = _.find(override, (over) => _.has(over, parentData));
        f = Object.assign(f, _.get(findObj, parentData));
      }
      f.ref = parentData;
      setActiveItems([f]);
    }
  }
  // eslint-disable-next-line
  }, [showing, parentValue]);

  if (!showing) {
    return null;
  }
  return (
    <div
      className="w-100"
      id={"reveal-" + _.get(parentItem, "ref")}
      hidden={!_.get(data, _.get(parentItem, "ref"))}>
      {renderAlternateFormFields(
        activeItems,
        isEditing,
        handleOption,
        data,
        error,
        dueDate,
        handleMultiple
      )}
      <Modal className="modal"
             backdrop="static"
             show={alert}
             centered
             dialogClassName="modalDialog">
        <Modal.Header className="modalHeader">
          <Modal.Title className="modalHeaderTitle">Action Required</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <p>{alertMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <StyledBlueButton
            onClick={() => {
              setAlert(false);
            }}
            variant="secondary">
            OK
          </StyledBlueButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

Reveal.defaultProps = {
  parentItem: {},
  data: {},
  isEditing: true,
  classes: null,
  handleOption: (key, value) => {/*We are sending handleOption function as a default Prop*/},
  showing: false,
  items: [],
  parentValue: null,
  error: {},
  dueDate: "",
  handleMultiple: () => {/*We are sending handleMultiple function as a default Prop*/},
  mode: null
};

export default Reveal;
